import ProductSupport from '@elem/compCommon/ProductConstructor/Support';
import { useEffect, useState } from 'react';
import EcoTab, { EcoTabItemProps } from 'eco-design/elements/eco-tab';
import { pageParams } from '../../config/page';
import getProductSupport from '../../context/getSupport';
import css from './index.module.scss';
import { Spin } from 'antd';
import { useRouter } from 'next/router';

export default function Support({ supportData, theme, productMsg }: any) {
    const { locale = '' } = useRouter();
    const { generalKeys, generalKeys_eu, generalKeys_jp, generalKeys_ph, generalKeys_nl } = pageParams;
    const IS_EU: boolean = ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale);
    const currentGeneralKeys =
        locale === 'nl' ? generalKeys_nl : IS_EU ? generalKeys_eu : locale === 'jp' ? generalKeys_jp : locale === 'ph' ? generalKeys_ph : generalKeys;
    const [active, setActive] = useState(currentGeneralKeys[0]);
    const len = currentGeneralKeys?.length || 0;

    const [supportActive, setSupportActive] = useState('faq');
    const tabs: EcoTabItemProps[] = currentGeneralKeys.map((generalKey: string) => ({
        tabLabel: productMsg[generalKey]?.name || generalKey || '',
        tabValue: generalKey,
    }));

    const _getActiveFolder = (curSupportData: any) => {
        const { faqList = [], videoList = [] } = curSupportData;
        if (faqList?.length > 0) {
            return 'faq';
        } else if (videoList?.length > 0) {
            return 'tutorial';
        } else {
            return 'manuals';
        }
    };

    const handleTabChange = (_: any, k: number) => {
        setActive(currentGeneralKeys[k]);
        if (supportData?.[currentGeneralKeys[k]]) {
            setSupportActive(_getActiveFolder(supportData[currentGeneralKeys[k]]));
        }
    };

    useEffect(() => {
        if (supportData && supportData[active]) {
            setSupportActive(_getActiveFolder(supportData[active]));
        }
    }, [supportData, active]);

    return (
        <div className={`support ${css.support}`}>
            {len > 0 ? (
                <>
                    {len > 1 && len === tabs?.length && (
                        <div className="tab-sticky-box" style={{ backgroundColor: theme }}>
                            <EcoTab items={tabs} activeKey={tabs[0].tabValue} onChange={handleTabChange} theme={theme} />
                        </div>
                    )}
                    {supportData && supportData[active] && productMsg[active].spuId ? (
                        <ProductSupport supportActive={supportActive} supportData={supportData[active]} theme={theme} spuId={productMsg[active].spuId} />
                    ) : (
                        <>
                            {getProductSupport(active)}
                            <Spin />
                        </>
                    )}
                </>
            ) : (
                <>
                    {getProductSupport(active)}
                    <Spin />
                </>
            )}
        </div>
    );
}
